import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import styles from './selectable-row.styles';

const SelectableRow = ({ id, onClick, children, classes, value, ...rest }) => {
  const handleClick = () => {
    onClick(id, value);
  };

  return (
    <TableRow
      hover
      id={id}
      classes={{ hover: classes.hover, root: classes.root }}
      onClick={onClick && handleClick}
      role="link"
      {...rest}
    >
      {children}
    </TableRow>
  );
};

SelectableRow.propTypes = {
  id: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  value: PropTypes.any
};

SelectableRow.defaultProps = {
  // `value` is deliberately left undefined rather than defaulting to null: it is forwarded as
  // onClick(id, value), and a null second argument silently bypasses the receiving handler's
  // parameter defaults (defaults only apply to undefined). That broke every document-row click
  // when the null reached the AWS SDK v3 presigner as `expiresIn`. See #33733.
  onClick: null
};

export default withStyles(styles)(SelectableRow);
